import { getAcceptLanguage } from '../xStateManagement/sessionBased';

const commonHeaders = {
  mode: 'cors',
  'Access-Control-Allow-Origin': 'true',
  'Accept-Language': getAcceptLanguage(),
  'x-ibinder-bypassimpersonate': 'true'
  // TODO: COMMENT
  // authorization: `Bearer ${localStorage.getItem('access_token')}`,
};

export default commonHeaders;
